import { useDispatch, useSelector } from "react-redux";
import "./edit-profile.css";
import { useState } from "react";
import { BASE_URL, ERROR } from "../assets/constant";
import axios from "axios";
import { CustomModal } from "../components/custom-modal";
import { logout } from "../redux/authSlice";
import Messages from "../components/message";
export const ChangePassword = () => {
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showPass, setShowPass] = useState({
    current_password: false,
    new_password: false,
    confirm_password: false
  });

  const [data, setData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: ""
  });
  const [showModal, setShowModal] = useState(false);

  const handleValueChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value
    }));
    console.log(name, value);
  };

  const handleRedirect = () => {
    window.history.back();
  };

  const togglePassword = (name) => {
    setShowPass((prev) => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const { new_password, current_password } = data;
      await axios.post(
        `${BASE_URL}/users/change-password`,
        {
          email: user.user.email,
          current_password,
          new_password
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );
      setShowModal(true);
    } catch (error) {
      setAlertType(ERROR);
      setAlertMessage(error?.response?.data?.message || "Something went wrong");
      setAlert(true);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    setShowModal(false);
  };

  const isButtonDisabled = () =>
    !data.current_password ||
    !data.new_password ||
    !data.confirm_password ||
    data.new_password !== data.confirm_password;

  return (
    <div className="subscriber-container">
      <div className="edit-profile-container">
        <header>
          <div style={{ display: "flex", fontSize: "16px", fontWeight: "600" }}>
            <button
              className="fa-solid fa-arrow-left"
              style={{
                display: "flex",
                fontSize: "16px",
                alignItems: "center",
                paddingRight: "10px",
                cursor: "pointer",
                textDecoration: "none",
                border: "none",
                background: "none"
              }}
              onClick={handleRedirect}></button>
            <h5>Change Password</h5>
          </div>
        </header>
        {showModal && (
          <CustomModal
            isOpen={showModal}
            closeModal={handleLogout}
            heading="Password Updated"
            text={`Your password has been updated successfully. Please login with your new password.`}
            btnName={"Close"}
            onClick={handleLogout}
          />
        )}
        {alert && (
          <Messages
            type={alertType}
            message={alertMessage}
            onClose={() => setAlert(false)}
          />
        )}
        <div className="edit-profile-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="current_password">Current Passowrd</label>
              <div className="d-flex">
                <input
                  type={showPass.current_password ? "text" : "password"}
                  className="form-control"
                  id="current_password"
                  name="current_password"
                  placeholder="Enter Current Password"
                  onChange={handleValueChange}
                  value={data.current_password}
                  style={{
                    paddingRight: "50px"
                  }}
                  required
                />
                <button
                  type="button"
                  className={`fa-solid ${
                    showPass.current_password ? "fa-eye-slash" : "fa-eye"
                  }`}
                  style={{
                    border: "none",
                    background: "none",
                    borderRadius: "5px",
                    marginLeft: "-40px",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "gray"
                  }}
                  onClick={() => togglePassword("current_password")}></button>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="new_password">New Passowrd</label>
              <div className="d-flex">
                <input
                  type={showPass.new_password ? "text" : "password"}
                  className="form-control"
                  id="new_password"
                  placeholder="Enter New Password"
                  onChange={handleValueChange}
                  name="new_password"
                  style={{
                    paddingRight: "50px"
                  }}
                  value={data.new_password}
                  minLength={8}
                  title="Password must be at least 8 characters"
                  required
                />
                <button
                  type="button"
                  className={`fa-solid ${
                    showPass.new_password ? "fa-eye-slash" : "fa-eye"
                  }`}
                  style={{
                    border: "none",
                    background: "none",
                    borderRadius: "5px",
                    marginLeft: "-40px",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "gray"
                  }}
                  onClick={() => togglePassword("new_password")}></button>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="confirm_password">Confirm New Password</label>
              <div className="d-flex">
                <input
                  type={showPass.confirm_password ? "text" : "password"}
                  className="form-control"
                  id="confirm_password"
                  placeholder="Confirm New Password"
                  onChange={handleValueChange}
                  name="confirm_password"
                  style={{
                    paddingRight: "50px"
                  }}
                  value={data.confirm_password}
                  required
                />
                <button
                  type="button"
                  className={`fa-solid ${
                    showPass.confirm_password ? "fa-eye-slash" : "fa-eye"
                  }`}
                  style={{
                    border: "none",
                    background: "none",
                    borderRadius: "5px",
                    marginLeft: "-40px",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "gray"
                  }}
                  onClick={() => togglePassword("confirm_password")}></button>
              </div>
              <label htmlFor="confirm_password" className="text-danger">
                {data.new_password !== data.confirm_password &&
                data.confirm_password
                  ? "Password does not match"
                  : ""}
              </label>
            </div>
            <button
              type="submit"
              className={`${
                !isButtonDisabled() ? "recallButton" : "disabledButton"
              }`}
              disabled={isButtonDisabled()}
              style={{
                borderRadius: "5px"
              }}>
              Update
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
